export default "__VITE_ASSET__ecc923a0__"